import { API_ORIGIN } from '../config'
const API_BASE = `${API_ORIGIN}/api`

// Los errores del servidor viajan como { error: 'CODIGO' }; los dejamos en err.code para que la UI los traduzca.
async function request(url, options) {
  const res = await fetch(url, options)
  const data = await res.json().catch(() => ({}))
  if (!res.ok) {
    const err = new Error(data.error || 'REQUEST_FAILED')
    err.code = data.error || 'REQUEST_FAILED'
    err.status = res.status
    throw err
  }
  return data
}

const json = (method, body) => ({ method, headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(body) })

export const getPlanOverview = (parkId) => request(`${API_BASE}/parks/${parkId}/billing/plan`)

// planId null = cancelar la solicitud de cambio pendiente.
export const requestPlanChange = (parkId, planId) => request(`${API_BASE}/parks/${parkId}/billing/plan-request`, json('POST', { planId }))

export const saveFiscalData = (parkId, payload) => request(`${API_BASE}/parks/${parkId}/billing/fiscal`, json('PATCH', payload))

// Descarga un PDF (un comprobante, o todos si no se pasa paymentId).
export async function downloadReceipt(parkId, paymentId, filename) {
  const url = paymentId ? `${API_BASE}/parks/${parkId}/billing/receipts/${paymentId}` : `${API_BASE}/parks/${parkId}/billing/receipts`
  const res = await fetch(url)
  if (!res.ok) {
    const data = await res.json().catch(() => ({}))
    const err = new Error(data.error || 'DOWNLOAD_FAILED')
    err.code = data.error || 'DOWNLOAD_FAILED'
    throw err
  }
  const blob = await res.blob()
  const href = URL.createObjectURL(blob)
  const a = document.createElement('a')
  a.href = href
  a.download = filename
  document.body.appendChild(a)
  a.click()
  a.remove()
  setTimeout(() => URL.revokeObjectURL(href), 2000)
}